module.exports = __webpack_public_path__ + "media/images/admin/icons/lock-879c3784d96834cc7d978f25feff5a39.svg";